import ModelState from './_util/model';

class ProductState extends ModelState {
  get url() { return '/products'; }
  get singular() { return 'product'; }
  get plural() { return 'products'; }
  get extra() { return 'currency'; }
}

export default ProductState;



// WEBPACK FOOTER //
// ./spa/state/products.jsx